import { type FC, type ReactNode, type RefObject, useRef } from 'react'
import { useIntl } from 'react-intl'

import { AD_BANNER_AUTO_REFRESH_SLIDE_ID } from '../../adServerConst'
import { type BannerData } from '../../model/adServerTypes'

import { AdServerBannerNavigation } from './AdServerBannerNavigation'

type AdServerBannerWrapperProps = {
  bannerData?: BannerData
  bannerRef: RefObject<HTMLDivElement | null>
  children: ReactNode
  className?: string
  isCarousel: boolean
}

export const AdServerBannerWrapper: FC<AdServerBannerWrapperProps> = ({
  bannerData,
  bannerRef,
  children,
  isCarousel,
  ...restProps
}) => {
  const intl = useIntl()
  const carouselRef = useRef<HTMLElement>(null)

  if (!isCarousel) {
    return <div {...restProps}>{children}</div>
  }

  const adBannerTitle = intl.formatMessage({
    id: 'adBanner.title',
  })

  return (
    <section
      aria-label={intl.formatMessage({
        id: 'adBanner.carousel.aria',
      })}
      aria-roledescription="carousel"
      className="relative mx-auto w-fit max-w-full"
      ref={carouselRef}
    >
      <section
        aria-roledescription="slide"
        id={AD_BANNER_AUTO_REFRESH_SLIDE_ID}
        {...restProps}
      >
        {children}
      </section>
      {bannerData ? (
        <>
          {(bannerData.totalCount ?? 1) > 1 ? (
            <AdServerBannerNavigation
              bannerRef={bannerRef}
              carouselRef={carouselRef}
              currentIndex={bannerData.currentIndex ?? 0}
              totalCount={bannerData.totalCount ?? 1}
            />
          ) : null}
          <span aria-live="polite" className="sr-only">
            {adBannerTitle}
            {' - '}
            {(bannerData.currentIndex ?? 0) + 1}
            {' / '}
            {bannerData.totalCount ?? 1}
          </span>
        </>
      ) : null}
    </section>
  )
}
